import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    adminInfo: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setAdminInfo(state, info) {
      state.adminInfo = info
    }
  },
  actions: {},
  modules: {}
})

